import axios from "axios";
import { Button, DataGrid } from "devextreme-react";
import {
  Column,
  Editing,
  Item,
  Scrolling,
  Toolbar,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useCallback, useEffect, useRef, useState } from "react";

export default function PaymentVendorMonthly(props) {
  const { unitCost, id } = props.data.data;
  const { vendorGridRef } = props;

  // const [columns, setColumns] = useState(async () => {
  //   const result = await axios.get(
  //     `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/vendor/mthly/${contrNo}/${name}/${type}`
  //   );

  //   return result.data;
  // });
  const paymentVendorMonthlyGridRef = useRef(null);

  const [dataSource, setDataSource] = useState(null);

  useEffect(async () => {
    // console.debug("[useEffect of PaymentVendorMonthly]");

    const result = await axios.get(
      // `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/vendor/mthly/yearMonth/${contrNo}/${name}/${type}`
      `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/vendor/mthly/yearMonth/${id}`
    );

    // paymentVendorMonthlyGridRef.current.instance.option("columns", [
    //   { caption: "2024-10" },
    //   { caption: "2024-11" },
    // ]);
    // paymentVendorMonthlyGridRef.current.instance.refresh(true);
    result.data.map((column) => {
      if (paymentVendorMonthlyGridRef.current) {
        paymentVendorMonthlyGridRef.current.instance.addColumn({
          ...column,
          width: 100,
          format: ",##0.###",
          // format: "#,##0",
          // calculateCellValue: calculateCellValue,/
          // editCellComponent: { ProgressRate },
          showEditorAlways: true,
          editorOptions: {
            placeholder: "Enter",
          },
        });
      }
    });

    setDataSource(
      new CustomStore({
        key: ["id", "yearMonth"],
        load: async () => {
          // console.debug("[load]");

          const result = await axios.get(
            // `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/vendor/mthly/${contrNo}/${name}/${type}?unitCost=${unitCost}`
            `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/vendor/mthly/${id}?unitCost=${unitCost}`
          );

          return result.data;
        },
        update: async (key, value) => {
          // console.debug("[update]");

          if (key.yearMonth == "Progress Rate") {
            await axios.put(
              // `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/vendor/mthly/${contrNo}/${name}/${type}`,
              `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/vendor/mthly/${key.id}`,
              value
            );
          }
        },
      })
    );

    // setColumns(await result.data);

    // console.debug("columns", columns);
    // }, [name, contrNo, type]);
  }, [id]);

  const onSaved = (e) => {
    vendorGridRef.current.instance.refresh();
  };

  const onEditorPreparing = (e) => {
    // console.debug("[onEditorPreparing]");

    const onValueChangedDefaultHandler = e.editorOptions.onValueChanged;

    if (e.row.key.yearMonth == "Progress Rate") {
      e.editorOptions.onValueChanged = function (args) {
        paymentVendorMonthlyGridRef.current.instance.cellValue(
          1,
          e.dataField,
          args.value * unitCost
        );

        onValueChangedDefaultHandler(args);
      };
    }
  };

  const onFocusedCellChanging = (e) => {
    if (e.newRowIndex == 1 || e.newColumnIndex == 0) {
      e.cancel = true;
    }
  };

  const onCellPrepared = (e) => {
    if (e.rowType == "header") {
      e.cellElement.style.fontWeight = "bold";
      e.cellElement.style.textAlign = "center";
      e.cellElement.style.backgroundColor = "#A9D08E";
    }
  };

  const onClickPlus = (e) => {
    const columns =
      paymentVendorMonthlyGridRef.current.instance.option("columns");
  };

  const onEditingStart = useCallback((e) => {
    if (e.data.yearMonth == "Cost") {
      e.cancel = true;
    }
  }, []);

  return (
    <DataGrid
      ref={paymentVendorMonthlyGridRef}
      dataSource={dataSource}
      allowColumnResizing={true}
      allowColumnReordering={false}
      columnResizingMode="widget"
      rowAlternationEnabled={false}
      showBorders={true}
      showRowLines={true}
      showColumnLines={true}
      width={"100%"}
      height={"100%"}
      repaintChangesOnly={true}
      highlightChanges={true}
      columnAutoWidth={true}
      onEditorPreparing={onEditorPreparing}
      // wordWrapEnabled={true}
      // columns={columns}
      onSaved={onSaved}
      onEditingStart={onEditingStart}
      // onRowUpdating={onRowUpdating}
      // onEditorPrepared={onEditorPrepared}
      // onCellPrepared={onCellPrepared}/
      // onOptionChanged={onOptionChanged}/
      // onFocusedCellChanging={onFocusedCellChanging}
      onCellPrepared={onCellPrepared}
    >
      <Editing
        refreshMode={"reshape"}
        mode={"batch"}
        allowAdding={false}
        allowUpdating={true}
        allowDeleting={false}
        selectTextOnEditStart={true}
        startEditAction={"dblClick"}
      />

      <Scrolling mode={"standard"} showScrollbar={"always"} />
      <Column dataField={"yearMonth"} caption={"Year-Month"} />

      <Toolbar>
        {/* <Item location={"after"}>
          <Button icon="plus" onClick={onClickPlus} />
        </Item> */}
        <Item name={"saveButton"} />
        <Item name={"revertButton"} />
      </Toolbar>
    </DataGrid>
  );
}
